import axios from 'axios';

export const logOutKeycloakSession = async (idToken?: string) => {
    await axios.get(
        `${process.env.KEYCLOAK_ISSUER}/protocol/openid-connect/logout`,
        {
            params: { id_token_hint: idToken },
        },
    );
};
